import { Component, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LibraryService } from '../../library.service';
import { AggregationResult } from '../../model/everything-search-result';
import { KeyValueCount, toKeyValueCount } from '../../utils/key-value-count';
import { SearchFilterValueListComponent } from '../search-filter-value-list/search-filter-value-list.component';

@Component({
  selector: 'app-search-filter-library',
  templateUrl: './search-filter-library.component.html',
  styleUrls: [ './search-filter-library.component.scss' ],
  imports: [ SearchFilterValueListComponent ]
})
export class SearchFilterLibraryComponent implements OnChanges {
  private libraryService = inject(LibraryService);

  @Input() aggregation: AggregationResult[];
  @Output() visible = new BehaviorSubject<boolean>(false);
  keyValues: KeyValueCount[] = [];

  async ngOnChanges({ aggregation }: SimpleChanges) {
    if (!aggregation?.currentValue) {
      return;
    }

    const libraries = await this.libraryService.getLibraries();

    this.keyValues = toKeyValueCount(
      aggregation.currentValue,
      key => libraries.find(it => it.id === key)?.displayName ?? key
    );
  }

}
